(function () {
  if (window.propultechGa4EventsLoaded) {
    return;
  }

  window.propultechGa4EventsLoaded = true;

  var DEDUPE_WINDOW_MS = 400;
  var recentEvents = new Map();
  var sentHomeImpressions = new Set();

  function normalizeValue(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function normalizeUrl(value) {
    var normalized = normalizeValue(value);

    if (!normalized) {
      return '';
    }

    try {
      return new URL(normalized, window.location.origin).href;
    } catch (error) {
      return normalized;
    }
  }

  function buildPayload(element) {
    var eventName = normalizeValue(element.getAttribute('data-ga4-event'));

    if (!eventName) {
      return null;
    }

    var thirdLevel = normalizeValue(element.getAttribute('data-ga4-third-level'));

    if (eventName === 'home_interactions') {
      if (thirdLevel) {
        thirdLevel = normalizeUrl(thirdLevel);
      } else if (element.href) {
        thirdLevel = normalizeUrl(element.href);
      }
    }

    return {
      event: eventName,
      first_level: normalizeValue(element.getAttribute('data-ga4-first-level')),
      second_level: normalizeValue(element.getAttribute('data-ga4-second-level')),
      third_level: thirdLevel
    };
  }

  function getPayloadSignature(payload) {
    return [
      payload.event,
      payload.first_level,
      payload.second_level,
      payload.third_level
    ].join('||');
  }

  function shouldDedupe(payload) {
    var signature = getPayloadSignature(payload);
    var now = Date.now();
    var lastSeenAt = recentEvents.get(signature);

    recentEvents.set(signature, now);

    return typeof lastSeenAt === 'number' && now - lastSeenAt < DEDUPE_WINDOW_MS;
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented) {
        return;
      }

      var trackedElement = event.target.closest('[data-ga4-event]');

      if (!trackedElement) {
        return;
      }

      var payload = buildPayload(trackedElement);

      if (!payload || shouldDedupe(payload)) {
        return;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    },
    true
  );

  function setupHomeImpressionTracking() {
    if (typeof IntersectionObserver !== 'function') {
      return;
    }

    var trackedElements = document.querySelectorAll(
      '#main-content [data-ga4-event="home_interactions"]'
    );

    if (!trackedElements.length) {
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) {
            return;
          }

          var payload = buildPayload(entry.target);

          if (!payload) {
            observer.unobserve(entry.target);
            return;
          }

          payload.event = 'home_views';
          var signature = getPayloadSignature(payload);

          if (!sentHomeImpressions.has(signature)) {
            sentHomeImpressions.add(signature);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(payload);
          }

          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.5 }
    );

    trackedElements.forEach(function (element) {
      observer.observe(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupHomeImpressionTracking, {
      once: true
    });
  } else {
    setupHomeImpressionTracking();
  }
})();
